import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext({ user: null, login: async () => {}, logout: async () => {} });

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    }, []);

    const value = useMemo(
        () => ({
            user,
            login: async (email, password) => {
                const { data } = await api.post("/auth/login", { email, password });
                setUser(data);
                return data;
            },
            logout: async () => {
                await api.post("/auth/logout").catch(() => {});
                setUser(false);
            },
        }),
        [user]
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
